import React, { Component } from "react";
import {Form, Container, Row, Col, Alert, Button, Accordion, Card, Carousel} from "react-bootstrap";
import {Jumbotron} from "../../helpers/Jumbotron";
import Axios from 'axios';
import {withRouter} from "../../helpers/withRouter";
import Footer from "../../Footer";
import EditBoardField from "./EditBoardField";
import EditBoardCompliance from "./EditBoardCompliance";
import EditBoardPOI from "./EditBoardPOI";
import loadingSvg from "../../images/loading.svg";
import AddBoardField from "./AddBoardField";
import {ContextAwareToggle} from "../../bootstrapOverwrites/ContextAwareToggleComponent";
import {ReactComponent as ArrowSvg} from "../../images/arrow.svg";
import {Link} from "react-router-dom";
import {ReactComponent as EditSvg} from "../../images/edit-regular.svg";
import AddBoardCompliance from "./AddBoardCompliance";
import AddBoardPOI from "./AddBoardPOI";
import EditImageModal from "./EditImageModal";
import {getUrlExtension} from "../../helpers/Helpers";
import {ReactComponent as TrashIcon} from "../../images/trash-alt-regular.svg";
import {ReactComponent as CopySVG} from "../../images/copy-regular.svg"
import defaultBillboardImage from "../../images/default-billboard.jpeg";

class EditBoard extends Component{
    state = {
        campaign:{},
    };
    constructor(props) {
        super(props);
        // This binding is necessary to make `this` work in the callback
        this.updateBoard = this.updateBoard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.deleteImg = this.deleteImg.bind(this);
    }

    dismissAlerts = (event) => {
        this.setState({campaignGetError:undefined})
    }

    componentDidMount() {
        this.getBoardApi()
    }
    updateBoard(board){
        this.setState({board: board});
    }

    deleteImg(boardImg){
        let data = new FormData();
        data.append("boardImgUrl",boardImg);
        data.append("campaignId",this.props.match.params.campaignId);
        let url = new URLSearchParams(window.location.search);
        data.append("boardId",url.get("board"));
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/delete-img", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
            this.getBoardApi()
        }).catch(error => {
            console.log(error.message)
            console.log(error.response)
        });
    }

    duplicateBoard() {
        let url = new URLSearchParams(window.location.search);
        let boardId = url.get("board");
        let campaignId = this.props.match.params.campaignId;
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/duplicate-board",{
            boardId: boardId,
            campaignId: campaignId,
        },{
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            this.setState({alert:{
                    title:"Board Duplicated!",
                    body:"The media has been successfully duplicated."
                }});
            window.open(window.location.pathname+"?board="+escape(response.data.newBoardId), '_blank').focus();
            setTimeout(()=>{
                this.setState({
                    alert: null
                })
            },3000)
        }).catch(err => {
            this.setState({error:{
                    title:"Media unable to be duplicated!",
                    body:"Server reported an error: " +err,
                }});
            setTimeout(()=>this.setState({
                error: null
            }),3000)
        });
    }

    deleteBoard() {
        let url = new URLSearchParams(window.location.search);
        let boardId = url.get("board");
        console.log(boardId)
        let campaignId = this.props.match.params.campaignId;
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/delete-board",{
            boardId: boardId,
            campaignId: campaignId,
        },{
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            this.setState({board: undefined,alert:{
                    title:"Board Deleted!",
                    body:"The media has been successfully removed from the campaign. Redirecting to the campaign page..."
                }});
            setTimeout(()=>{
                this.setState({
                    alert: null
                })
                window.location.replace("/campaign/"+campaignId);
            },3000)
        }).catch(err => {
            this.setState({error:{
                    title:"Media unable to be deleted!",
                    body:"Server reported an error: " +err,
                }});
            setTimeout(()=>this.setState({
                error: null
            }),3000)
        });
    }
    onSubmit(event){
        event.preventDefault();
        event.stopPropagation();
        let url = new URLSearchParams(window.location.search);
        let boardId = url.get("board");
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/update-board", {
            boardId: boardId,
            campaignId: this.props.match.params.campaignId,
            board: this.state.board,
        },{
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            this.setState({
                board: response.data.board,
                alert:{
                    title:"Media Updated!",
                    body:"The media has been successfully updated."
                }});
            setTimeout(()=>this.setState({
                alert: null
            }),3000)
        }).catch(err => {
            this.setState({error:{
                    title:"Media unable to be updated!",
                    body:"Server reported an error: " +err,
                }});
            setTimeout(()=>this.setState({
                error: null
            }),3000)
        });
    }
    // originalBoard = {};
    getBoardApi(){
        let campaignId  = this.props.match.params.campaignId;
        let url = new URLSearchParams(window.location.search);
        let boardId = url.get("board");
        Axios.get(process.env.REACT_APP_BACKEND_URL + "/campaign/"+campaignId).then((response) => {
            if(response.data.campaign){
                let campaign = response.data.campaign;
                for(let key of Object.keys(campaign.boards)){
                    if(key === boardId){
                        // this.originalBoard = JSON.parse(JSON.stringify(campaign.boards[key]));//clone
                        this.setState({campaign: campaign, boardId: key, board: campaign.boards[key]});
                        return
                    }
                }
                this.setState({campaign: response.data.campaign,campaignGetError:"Unable to find media in campaign."});
            }else{
                this.setState({campaignGetError:"Unable to find campaign."});
            }
        }).catch(error => {
            console.log(error);
            if(error && error.response){
                this.setState({campaignGetError:error.response.data.message});
            }
        });
    }

    render() {
        const campaignGetError = this.state.campaignGetError;
        return<div className={"main-content"}>
        <Container>
            <Jumbotron style={{maxWidth:500}} className={"mx-auto mt-5 mb-5"}>
                <Form onSubmit={this.onSubmit}>
                    <Row>
                        <Col>
                            <h2>Edit Media</h2>
                            {this.state.board && this.state.board.fields &&  this.state.board.fields["unit #"] ?
                                <>
                                    <br/>
                                    <h5>Campaign: {this.state.campaign.name}</h5>
                                    <h5>Media: {this.state.board.fields["unit #"]}</h5>
                                    <br/>
                                    <p>Make sure to click <b>"Update Media"</b> when done editing.</p>
                                        <Row>
                                            <Col>
                                                {this.state.board.images && this.state.board.images.length ?
                                                    <Carousel>
                                                        {this.state.board.images.map(function (im) {
                                                            return <Carousel.Item>
                                                                {(()=>{
                                                                    if (getUrlExtension(im) === "pdf") {
                                                                        return <>
                                                                            <embed src={im} className={"w-100"} style={{height:300}}/>
                                                                        </>
                                                                    } else if (im && im.length) {
                                                                        return <img src={im} alt="billboard header"  className={"w-100"} />
                                                                    }
                                                                })()}
                                                            </Carousel.Item>
                                                        })}
                                                    </Carousel>:""}
                                                {this.state.board.images && this.state.board.images.length ?
                                                        this.state.board.images.map(function (im) {
                                                            return <div style={{width:100,height:80}} className={"d-inline-block me-2"}>
                                                                {(()=>{
                                                                    if (getUrlExtension(im) === "pdf") {
                                                                        return <>
                                                                            <embed src={im} className={"w-100 h-100"} />
                                                                        </>
                                                                    } else if (im && im.length) {
                                                                        return <img src={im}   alt="billboard header" className={"w-100"}/>
                                                                    }
                                                                })()}
                                                                <span onClick={()=>{this.deleteImg(im)}} className={"red-txt delete-board-btn boring-btn d-inline-block"}><TrashIcon/> Delete</span>
                                                            </div>
                                                        }.bind(this)):""}
                                            </Col>
                                        </Row>
                                    <Row>
                                        <Col className={"mt-2"}>
                                                <span onClick={()=>{
                                                    this.setState({showEditImgModal:true})
                                                }} className={"boring-btn"}><EditSvg/> Add Images
                                            </span>
                                        </Col>
                                    </Row>
                                </>
                                :<>
                                    <br/>
                                    <br/>
                                    <img className={"loading-icon-sm"} src={loadingSvg}  alt={"loading icon"}/>
                                </>}
                            <br/>
                        </Col>
                    </Row>
                    {this.state.board ?
                        <>
                            <Row>
                                <Col>
                                    <Accordion>
                                        <Card>
                                            {/*<Accordion.Toggle as={Card.Header} eventKey="0">*/}
                                            {/*    Metadata*/}
                                            {/*</Accordion.Toggle>*/}
                                            <Card.Header>
                                                {/*<Accordion.Toggle as={Card.Header} eventKey="2" onClick={()=>{this.props.togglePOIsPins()}}>*/}
                                                <ContextAwareToggle
                                                    eventKey="0"
                                                    // clickEvent={(ev)=>{this.putAtTop(ev);}}
                                                >Metadata <ArrowSvg className={"accordion-arrow"}/></ContextAwareToggle>
                                                {/*</Accordion.Toggle>*/}
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="0">
                                                <Card.Body>
                                                    <table className={"selected-card-accordion-table"}>
                                                        <tbody>
                                                        {Object.keys(this.state.board.fields).map((key) => {
                                                            return <EditBoardField
                                                                key={key}
                                                                field={key}
                                                                fieldValue={this.state.board.fields[key]}
                                                                board={this.state.board}
                                                                updateBoard={this.updateBoard}
                                                            />
                                                        })}
                                                        <AddBoardField
                                                            board={this.state.board}
                                                            updateBoard={this.updateBoard}
                                                        />
                                                        </tbody>
                                                    </table>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        {this.state.campaign.complianceOn ?
                                            <Card>
                                            {/*<Accordion.Toggle as={Card.Header} eventKey="0">*/}
                                            {/*    Metadata*/}
                                            {/*</Accordion.Toggle>*/}
                                            <Card.Header>
                                                {/*<Accordion.Toggle as={Card.Header} eventKey="2" onClick={()=>{this.props.togglePOIsPins()}}>*/}
                                                <ContextAwareToggle
                                                    eventKey="1"
                                                    // clickEvent={(ev)=>{this.putAtTop(ev);}}
                                                >Compliance <ArrowSvg className={"accordion-arrow"}/></ContextAwareToggle>
                                                {/*</Accordion.Toggle>*/}
                                            </Card.Header>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        {/*<div className={"compliance-accordion"}>*/}
                                                        {this.state.board.complianceArray && this.state.board.complianceArray.length ?
                                                            this.state.board.complianceArray.map((compliance,i) => {
                                                                return <EditBoardCompliance
                                                                    key={i}
                                                                    compliance={compliance}
                                                                    board={this.state.board}
                                                                    updateBoard={this.updateBoard}
                                                                />
                                                            }):<i>No Compliance Found</i>}
                                                        {/*</div>*/}
                                                        <hr className={"w-100"}/>
                                                        <AddBoardCompliance
                                                            board={this.state.board}
                                                            updateBoard={this.updateBoard}
                                                        />
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                        </Card>: <></>}
                                        {/*<Card>*/}
                                        {/*    /!*<Accordion.Toggle as={Card.Header} eventKey="0">*!/*/}
                                        {/*    /!*    Metadata*!/*/}
                                        {/*    /!*</Accordion.Toggle>*!/*/}
                                        {/*    <Card.Header>*/}
                                        {/*        /!*<Accordion.Toggle as={Card.Header} eventKey="2" onClick={()=>{this.props.togglePOIsPins()}}>*!/*/}
                                        {/*        <ContextAwareToggle*/}
                                        {/*            eventKey="2"*/}
                                        {/*            // clickEvent={(ev)=>{this.putAtTop(ev);}}*/}
                                        {/*        >POIs <ArrowSvg className={"accordion-arrow"}/></ContextAwareToggle>*/}
                                        {/*        /!*</Accordion.Toggle>*!/*/}
                                        {/*    </Card.Header>*/}
                                        {/*    <Accordion.Collapse eventKey="2">*/}
                                        {/*        <Card.Body>*/}
                                        {/*            /!*<div className={"compliance-accordion"}>*!/*/}
                                        {/*            {this.state.board.poisArray && this.state.board.poisArray.length ?*/}
                                        {/*                this.state.board.poisArray.map((poi) => {*/}
                                        {/*                    return <EditBoardPOI*/}
                                        {/*                        key={poi.place_id}*/}
                                        {/*                        poi={poi}*/}
                                        {/*                        board={this.state.board}*/}
                                        {/*                        updateBoard={this.updateBoard}*/}
                                        {/*                    />*/}
                                        {/*                }) : <>*/}
                                        {/*                    <i>No POIs Found</i>*/}
                                        {/*                </>}*/}
                                        {/*            /!*</div>*!/*/}
                                        {/*            <hr className={"w-100"}/>*/}
                                        {/*            <AddBoardPOI*/}
                                        {/*                board={this.state.board}*/}
                                        {/*                update={this.updateBoard}*/}
                                        {/*            />*/}
                                        {/*        </Card.Body>*/}
                                        {/*    </Accordion.Collapse>*/}
                                        {/*</Card>*/}
                                    </Accordion>
                                </Col>
                            </Row>
                            <Row className={"mt-4"}>
                                <Col className={"text-left"}>
                                    <span onClick={()=>{this.duplicateBoard()}} className={"boring-btn mt-1 d-inline-block"}><CopySVG/> Duplicate</span>
                                    <br/>
                                    <span onClick={()=>{this.deleteBoard()}} className={"red-txt delete-board-btn boring-btn mt-1 d-inline-block"}><TrashIcon/> Delete</span>
                                </Col>
                                <Col className={"text-right"}>
                                    {/*TODO: add trash svg*/}
                                    <span onClick={function (){
                                        window.location.reload();
                                    }} className={"me-2 boring-btn"}>Reset</span>
                                    <Button variant="primary" type="submit">
                                        Update Media
                                    </Button>
                                </Col>
                            </Row>
                        </> :<></>
                    }
                </Form>
            </Jumbotron>
            {campaignGetError ? (
                <Alert style={{maxWidth:500}} className={"mx-auto"}  variant="danger" onClose={this.dismissAlerts} dismissible>
                    <Alert.Heading>Error Finding Campaign or Media!</Alert.Heading>
                    <p>Server Reported an Error: {campaignGetError}. Please try again.</p>
                </Alert>
            ):(
                <></>
            )}
            {this.state.alert ? (
                <Alert style={{maxWidth:500}} className={"mx-auto alert-top-right"}  variant="success" onClose={()=>{this.setState({alert: null})}} dismissible>
                    <Alert.Heading>{this.state.alert.title}</Alert.Heading>
                    <p>{this.state.alert.body}</p>
                </Alert>
            ):(
                <></>
            )}
            {this.state.error ? (
                <Alert style={{maxWidth:500}} className={"mx-auto alert-top-right"}  variant="danger" onClose={()=>{this.setState({error: null})}} dismissible>
                    <Alert.Heading>{this.state.error.title}</Alert.Heading>
                    <p>{this.state.error.body}</p>
                </Alert>
            ):(
                <></>
            )}
            <Footer/>
        </Container>
            <EditImageModal
                campaignId={this.state.campaign._id}
                boardId={this.state.boardId}
                show={this.state.showEditImgModal}
                handleImageChange={(board) => {
                    this.setState({
                        board: board,
                        alert:{
                            title:"Images Added!",
                            body:"The media has been successfully updated."
                        }});
                    setTimeout(()=>this.setState({
                        alert: null
                    }),3000)
                }}
                onHide={()=>{
                    this.setState({showEditImgModal:false})
                }}
            />
        </div>
    }
}

export default withRouter(EditBoard);
